/// <reference types="vite/client" />

import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'http://localhost:54321';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbG...';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Helper function to set current hospital context
export function setHospitalContext(hospitalId: number): void {
  localStorage.setItem('hospital_id', hospitalId.toString());
  // Set the Postgres session variable for RLS
  supabase.rpc('set_hospital_context', { hospital_id: hospitalId });
}

// Helper to get current hospital ID
export function getCurrentHospitalId(): number | null {
  const id = localStorage.getItem('hospital_id');
  return id ? parseInt(id, 10) : null;
}

// Types for API responses (shared with backend)
export interface ApiError {
  message: string;
  code?: string;
  details?: any;
}

export interface PaginatedResponse<T> {
  data: T[];
  total: number;
  page: number;
  pageSize: number;
  totalPages: number;
}
